<template>
  <div>
    <NBar title="商户品牌名称" :top="true"/>
    <div class="subject">
      <div class="title">在部分功能中展示出商品品牌，如：游戏币红包的标题</div>
      <nut-textinput v-model="form.name" placeholder="请输入标题名称，如：宝贝王" :clearBtn="true" :disabled="false"
                     class="input"/>
      <nut-button block class="btn" @click="save">保存</nut-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'brandName',
  data () {
    return {
      user: {},
      form: {}
    }
  },
  mounted () {
    this.user = this.$api.user
    this.getData()
  },
  methods: {
    getData () {
      this.$api.get({
        url: '/merchant/merchant/get/',
        id: this.$api.merId
      }).then(res => {
        if (!this.$util.isArrOrNull(res.data)) {
          this.form = res.data
        }
      })
    },
    save () {
      this.$api.post({
        url: '/merchant/merchant/update',
        data: this.form
      }).then(() => {
        this.$toast.success('修改成功')
        setTimeout(() => {
          this.$router.go(-1)
        }, 2000)
      })
    }
  }
}
</script>

<style scoped>
  .subject {
    margin: 0 15px;
  }

  .subject .title {
    height: 35px;
    line-height: 35px;
    margin-top: 5px;
    text-align: center;
    color: #848484;
  }

  .subject .input {
    margin: 5px 0;
  }

  .subject .btn {
    margin-top: 10px;
    border-radius: 5px;
  }

  >>> .nut-button {
    background: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/BrandName.vue